<script>
import gql from "graphql-tag";
import { tournamentCompetitorFragment } from "@/graphql/tournament";
import { DialogInputTypes } from "@/js/helper";
import BaseDialog from "./baseDialog.vue";

export default {
  name: "CompetitorPaymentDialog",
  extends: BaseDialog,
  props: { tournament: Object, competitor: Object },
  data: function() {
    return {
      payment: {
        label: "Payment amount",
        value: this.competitor.amountPaid,
        type: DialogInputTypes.number
      }
    };
  },
  computed: {
    dialogInputs: {
      get() {
        return [this.payment];
      }
    },
    title: {
      get() {
        return `Payment by ${this.competitor.name}`;
      }
    }
  },
  methods: {
    submit() {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation($tournamentId: ID!, $competitorId: ID!, $amount: Float!) {
              updateCompetitorPayment(
                tournamentId: $tournamentId
                competitorId: $competitorId
                amount: $amount
              ) {
                ...TournamentCompetitor
              }
            }
            ${tournamentCompetitorFragment}
          `,
          variables: {
            tournamentId: this.tournament.id,
            competitorId: this.competitor.id,
            amount: this.payment.value
          }
        })
        .then(result => {
          //this.$root.$emit("updateTournament", this.tournament.id);
          this.$store.commit(
            "setNotification",
            `Recorded payment of ${this.payment.value} by ${
              this.competitor.name
            }`
          );
        })
        .catch(err => {
          console.log(err);
          window.alert("Failed to set payment");
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// competitorPaymentDialog.vue?e00518da